module.exports = __webpack_public_path__ + "static/media/lesson-backto11.4cd3cbf8.png";